module.exports = __webpack_public_path__ + "img/16.9f614305.svg";